// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__16HHi","icon":"SortAdornment_icon__10Bp3","up":"SortAdornment_up__1yunY","down":"SortAdornment_down__31Xrq","active":"SortAdornment_active__12wlE"};